(function (root, factory) {
  var api = factory();
  if (typeof module === 'object' && module.exports) {
    module.exports = api;
  } else {
    root.CBMCartUx = api;
    if (api.boot && root.document) api.boot(root.document, root);
  }
})(typeof window !== 'undefined' ? window : globalThis, function () {
  'use strict';

  var booted = false;
  var providerUpdateQueued = false;

  function normalizeCodes(codes) {
    return (Array.isArray(codes) ? codes : [])
      .map(function (code) {
        return String(code || '').trim().replace(/,/g, '');
      })
      .filter(Boolean);
  }

  function buildDiscountPayload(codes, pathname) {
    return {
      discount: normalizeCodes(codes).join(','),
      sections: 'cart-drawer,cart-bubble',
      sections_url: pathname && pathname.charAt(0) === '/' ? pathname : '/cart'
    };
  }

  function discountCodesForSubmission(existingCodes, submittedCode) {
    return normalizeCodes([submittedCode]);
  }

  function nextScrollLeft(track, direction) {
    var maximum = Math.max(0, Number(track.scrollWidth) - Number(track.clientWidth));
    var step = Math.max(1, Math.round(Number(track.clientWidth) * 0.9));
    return Math.min(maximum, Math.max(0, Number(track.scrollLeft) + (direction < 0 ? -step : step)));
  }

  function hasRenderedCode(html, code, Parser) {
    var wanted = String(code || '').trim().toLowerCase();
    if (!wanted) return false;

    if (typeof Parser === 'function') {
      var parsed = new Parser().parseFromString(String(html || ''), 'text/html');
      return Array.prototype.some.call(parsed.querySelectorAll('[data-cbm-discount-code]'), function (chip) {
        return String(chip.getAttribute('data-cbm-discount-code') || '').trim().toLowerCase() === wanted;
      });
    }

    var source = String(html || '');
    var attribute = /data-cbm-discount-code\s*=\s*(["'])(.*?)\1/gi;
    var match;
    while ((match = attribute.exec(source))) {
      if (String(match[2]).trim().toLowerCase() === wanted) return true;
    }
    return false;
  }

  function replaceSections(document, sections, Parser) {
    if (!document || !sections || typeof Parser !== 'function') return false;
    var definitions = [
      { id: 'Cart-Drawer', section: 'cart-drawer', selector: '.cart-drawer', required: true },
      { id: 'cart-drawer-toggle', section: 'cart-bubble', selector: '.thb-item-count' }
    ];
    var updates = [];
    for (var index = 0; index < definitions.length; index += 1) {
      var definition = definitions[index];
      var host = document.getElementById(definition.id);
      var html = sections[definition.section];
      var parsed = typeof html === 'string'
        ? new Parser().parseFromString(html, 'text/html').querySelector(definition.selector)
        : null;
      if (!host || !parsed) {
        if (definition.required) return false;
        continue;
      }
      updates.push({ target: host.querySelector(definition.selector) || host, html: parsed.innerHTML });
    }
    updates.forEach(function (update) {
      update.target.innerHTML = update.html;
    });
    return true;
  }

  function finalizeCartMutation(operation, item, drawer, onError) {
    return Promise.resolve(operation).catch(function (error) {
      if (typeof onError === 'function') onError(error);
      return null;
    }).finally(function () {
      if (item && item.classList) item.classList.remove('thb-loading');
      if (drawer && typeof drawer.removeAttribute === 'function') drawer.removeAttribute('aria-busy');
    });
  }

  function requestWithTimeout(win, url, options, timeoutMs) {
    if (!win || typeof win.fetch !== 'function') return Promise.reject(new Error('cart-fetch-unavailable'));
    if (typeof win.AbortController !== 'function') return win.fetch(url, options);
    var controller = new win.AbortController();
    var requestOptions = Object.assign({}, options, { signal: controller.signal });
    var request = win.fetch(url, requestOptions);
    var timer;
    var timeout = new Promise(function (resolve, reject) {
      timer = win.setTimeout(function () {
        controller.abort();
        reject(new Error('cart-request-timeout'));
      }, timeoutMs);
    });
    return Promise.race([request, timeout]).finally(function () {
      win.clearTimeout(timer);
    });
  }

  function toastTop(document) {
    var header = document && typeof document.querySelector === 'function'
      ? document.querySelector('#header')
      : null;
    var rect = header && typeof header.getBoundingClientRect === 'function'
      ? header.getBoundingClientRect()
      : null;
    var bottom = rect ? Number(rect.bottom) : 0;
    return Math.max(12, Math.round((Number.isFinite(bottom) ? Math.max(0, bottom) : 0) + 12));
  }

  function requestDiscount(win, codes) {
    var route = String(win.theme && win.theme.routes && win.theme.routes.cart_update_url || '/cart/update');
    var url = route.replace(/\.js$/, '') + '.js';
    return requestWithTimeout(win, url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(buildDiscountPayload(codes, win.location && win.location.pathname))
    }, 8000).then(function (response) {
      if (!response.ok) throw new Error('discount-request-failed');
      return response.json();
    });
  }

  function rebindNativeCart(document, Controller) {
    var drawer = document && document.getElementById('Cart-Drawer');
    if (!drawer || typeof Controller !== 'function') return false;
    var controller = Object.create(Controller.prototype);
    controller.container = drawer;
    controller.removeProductEvent();
    controller.notesToggle();
    controller.termsCheckbox();
    return true;
  }

  function setFormBusy(form, busy) {
    if (!form) return;
    if (form.classList) form.classList.toggle('is-loading', busy);
    ['[data-cbm-discount-input]', 'button[type="submit"]'].forEach(function (selector) {
      var control = form.querySelector(selector);
      if (control) control.disabled = busy;
    });
  }

  function showDiscountFeedback(form, message) {
    var feedback = form && form.querySelector('[data-cbm-discount-feedback]');
    if (!feedback) return;
    feedback.textContent = message || '';
    feedback.hidden = !message;
  }

  function applyDiscount(document, win, form, codes, submittedCode, Parser, Controller) {
    setFormBusy(form, true);
    showDiscountFeedback(form, '');
    return requestDiscount(win, codes).then(function (state) {
      if (!replaceSections(document, state && state.sections, Parser)) {
        throw new Error('discount-sections-missing');
      }
      var currentForm = document.querySelector('[data-cbm-discount-form]') || form;
      if (submittedCode && !hasRenderedCode(state.sections['cart-drawer'], submittedCode, Parser)) {
        showDiscountFeedback(currentForm, currentForm.dataset.cbmDiscountInvalid);
      }
      try {
        rebindNativeCart(document, Controller);
        placeProviderWidgets(document.getElementById('Cart-Drawer'));
      } catch (optionalUiError) {
        // Shopify already accepted the discount; optional UI rebinds must not report a false failure.
      }
      setFormBusy(currentForm, false);
      return true;
    }).catch(function () {
      var currentForm = document.querySelector('[data-cbm-discount-form]') || form;
      showDiscountFeedback(currentForm, currentForm.dataset.cbmDiscountError);
      setFormBusy(currentForm, false);
      return false;
    });
  }

  function openCart(document, win) {
    var drawer = document.getElementById('Cart-Drawer');
    if (!drawer) return;
    document.body.classList.add('open-cc');
    drawer.classList.add('active');
    if (drawer.focus) drawer.focus();
    if (document.dispatchEvent && win.CustomEvent) {
      document.dispatchEvent(new win.CustomEvent('cart-drawer:open'));
    }
  }

  function showAddedToast(document, win) {
    var toast = document.querySelector('.cbm-cart-added-toast');
    if (!toast) {
      toast = document.createElement('div');
      toast.className = 'cbm-cart-added-toast';
      toast.setAttribute('role', 'status');
      toast.setAttribute('aria-live', 'polite');
      var message = document.createElement('span');
      message.className = 'cbm-cart-added-toast__message';
      message.textContent = win.theme.strings.addedToCart;
      var action = document.createElement('button');
      action.className = 'cbm-cart-added-toast__action';
      action.type = 'button';
      action.textContent = win.theme.strings.viewCart;
      action.addEventListener('click', function (event) {
        event.preventDefault();
        openCart(document, win);
        toast.classList.remove('is-visible');
      });
      toast.appendChild(message);
      toast.appendChild(action);
      document.body.appendChild(toast);
    }
    if (toast.style && typeof toast.style.setProperty === 'function') {
      toast.style.setProperty('--cbm-toast-top', toastTop(document) + 'px');
    }
    if (toast.cbmTimer) win.clearTimeout(toast.cbmTimer);
    toast.classList.add('is-visible');
    toast.cbmTimer = win.setTimeout(function () {
      toast.classList.remove('is-visible');
    }, 3500);
    return toast;
  }

  function syncShippingStatusFromHoppy(drawer) {
    if (!drawer || typeof drawer.querySelector !== 'function' || typeof drawer.querySelectorAll !== 'function') return null;
    var progress = drawer.querySelector('#shipping-container-cart_drawer .basic-bar-fill');
    var width = progress && progress.style ? parseFloat(progress.style.width) : NaN;
    if (!Number.isFinite(width)) return null;
    var status = width >= 99.5 ? 'free' : 'calculated';
    Array.prototype.forEach.call(drawer.querySelectorAll('[data-cbm-shipping-status]'), function (element) {
      var hidden = element.getAttribute('data-cbm-shipping-status') !== status;
      if (element.hidden !== hidden) element.hidden = hidden;
    });
    return status;
  }

  function placeProviderWidgets(drawer) {
    if (!drawer) return 0;
    var moves = 0;
    [
      ['#shipping-container-cart_drawer', '[data-cbm-hoppy-slot]', 'data-cbm-cart-progress'],
      ['.seal-widget', '[data-cbm-seel-slot]', 'data-cbm-provider-managed']
    ].forEach(function (definition) {
      var widget = drawer.querySelector(definition[0]);
      var slot = drawer.querySelector(definition[1]);
      if (!widget || !slot) return;
      widget.setAttribute(definition[2], '');
      if (widget.parentElement !== slot) {
        slot.appendChild(widget);
        moves += 1;
      }
    });

    var localizedSeelPrice = drawer.querySelector('[data-cbm-seel-localized-price]');
    var seelPrice = drawer.querySelector('[data-seel-wfp-price]');
    if (localizedSeelPrice && seelPrice) {
      var localizedText = String(localizedSeelPrice.textContent || '').trim();
      var currentText = String(seelPrice.textContent || '').trim();
      var labels = localizedSeelPrice.dataset || {};
      var prefix = labels.cbmSeelPrefix;
      if (typeof prefix !== 'string') {
        var amountStart = currentText.search(/[$€£¥0-9]/);
        prefix = amountStart > 0 ? currentText.slice(0, amountStart).trim() : '';
      }
      var nextText = localizedText
        ? (prefix ? prefix + ' ' : '') + localizedText
        : labels.cbmSeelPricePending;
      if (nextText && currentText !== nextText) seelPrice.textContent = nextText;
    }
    syncShippingStatusFromHoppy(drawer);
    return moves;
  }

  function scrollRecommendations(button) {
    var container = button && button.closest('[data-cbm-recommendations]');
    var track = container && container.querySelector('.complementary-products--inner');
    if (!track || typeof track.scrollTo !== 'function') return false;
    var direction = button.matches('[data-cbm-recommendation-prev]') ? -1 : 1;
    track.scrollTo({ left: nextScrollLeft(track, direction), behavior: 'smooth' });
    return true;
  }

  function updateRecommendationControls(container) {
    var track = container && container.querySelector('.complementary-products--inner');
    var previous = container && container.querySelector('[data-cbm-recommendation-prev]');
    var next = container && container.querySelector('[data-cbm-recommendation-next]');
    var controls = container && container.querySelector('.cbm-cart-recommendation-controls');
    if (!track || !previous || !next || !controls) return false;
    var maximum = Math.max(0, Number(track.scrollWidth) - Number(track.clientWidth));
    var hasOverflow = maximum > 1;
    controls.hidden = !hasOverflow;
    previous.disabled = !hasOverflow || Number(track.scrollLeft) <= 1;
    next.disabled = !hasOverflow || Number(track.scrollLeft) >= maximum - 1;
    return true;
  }

  function updateAllRecommendationControls(drawer) {
    if (!drawer || typeof drawer.querySelectorAll !== 'function') return;
    Array.prototype.forEach.call(drawer.querySelectorAll('[data-cbm-recommendations]'), updateRecommendationControls);
  }

  function manualCodes(drawer) {
    if (!drawer) return [];
    return Array.prototype.map.call(drawer.querySelectorAll('[data-cbm-discount-code]'), function (chip) {
      return chip.getAttribute('data-cbm-discount-code');
    });
  }

  function nativeCartController() {
    return typeof CartDrawer === 'function' ? CartDrawer : null;
  }

  function boot(document, win) {
    if (booted) return;
    var start = function () {
      if (booted) return;
      var drawer = document.getElementById('Cart-Drawer');
      var pageCart = document.getElementById('Cart');
      if (!drawer && !pageCart) return;
      booted = true;
      placeProviderWidgets(drawer);
      placeProviderWidgets(pageCart);
      updateAllRecommendationControls(drawer);

      document.addEventListener('submit', function (event) {
        var form = event.target;
        if (!form || !form.matches || !form.matches('[data-cbm-discount-form]')) return;
        event.preventDefault();
        var input = form.querySelector('[data-cbm-discount-input]');
        var code = input && input.value;
        if (!String(code || '').trim()) return;
        applyDiscount(document, win, form, discountCodesForSubmission(manualCodes(drawer), code), code, win.DOMParser, nativeCartController());
      });

      document.addEventListener('click', function (event) {
        var target = event.target && event.target.closest ? event.target : null;
        if (!target) return;
        var arrow = target.closest('[data-cbm-recommendation-prev], [data-cbm-recommendation-next]');
        if (arrow) {
          event.preventDefault();
          scrollRecommendations(arrow);
          return;
        }
        var remove = target.closest('[data-cbm-discount-remove]');
        if (!remove) return;
        event.preventDefault();
        var code = remove.getAttribute('data-cbm-discount-remove');
        var form = remove.closest('[data-cbm-discount-form]');
        var remaining = manualCodes(drawer).filter(function (value) {
          return String(value).toLowerCase() !== String(code).toLowerCase();
        });
        applyDiscount(document, win, form, remaining, '', win.DOMParser, nativeCartController());
      });

      document.addEventListener('cart:item-added', function () {
        showAddedToast(document, win);
      });

      document.addEventListener('scroll', function (event) {
        var track = event.target;
        if (!track || !track.matches || !track.matches('.complementary-products--inner')) return;
        updateRecommendationControls(track.closest('[data-cbm-recommendations]'));
      }, true);

      win.addEventListener('resize', function () {
        updateAllRecommendationControls(document.getElementById('Cart-Drawer'));
      });

      if (typeof win.MutationObserver === 'function') {
        var observer = new win.MutationObserver(function () {
          if (providerUpdateQueued) return;
          providerUpdateQueued = true;
          (win.requestAnimationFrame || win.setTimeout)(function () {
            providerUpdateQueued = false;
            var currentDrawer = document.getElementById('Cart-Drawer');
            placeProviderWidgets(currentDrawer);
            placeProviderWidgets(document.getElementById('Cart'));
            updateAllRecommendationControls(currentDrawer);
          });
        });
        [drawer, pageCart].forEach(function (container) {
          if (container) observer.observe(container, { attributes: true, attributeFilter: ['style'], characterData: true, childList: true, subtree: true });
        });
      }
    };

    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
    else start();
  }

  return {
    normalizeCodes: normalizeCodes,
    buildDiscountPayload: buildDiscountPayload,
    discountCodesForSubmission: discountCodesForSubmission,
    nextScrollLeft: nextScrollLeft,
    hasRenderedCode: hasRenderedCode,
    replaceSections: replaceSections,
    finalizeCartMutation: finalizeCartMutation,
    requestWithTimeout: requestWithTimeout,
    toastTop: toastTop,
    requestDiscount: requestDiscount,
    rebindNativeCart: rebindNativeCart,
    applyDiscount: applyDiscount,
    showAddedToast: showAddedToast,
    syncShippingStatusFromHoppy: syncShippingStatusFromHoppy,
    placeProviderWidgets: placeProviderWidgets,
    scrollRecommendations: scrollRecommendations,
    updateRecommendationControls: updateRecommendationControls,
    boot: boot
  };
});
